import { defineMessages } from 'react-intl';

export default defineMessages({
    lossDetailsProperty: {
        id: 'anonymous.wizard.fnol.pages.loss-details.Loss Details Property',
        defaultMessage: 'Loss details property'
    }
});
